import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {getCarbonOutput, getCarbonOutputPercentage, getCarbonOutputTarget} from '../../../../../store/reducers/outputs/carbonOutput';
import {countPowerSources} from '../../../../../store/reducers/powerSources';
import {scale, Scale} from 'chroma-js';


interface Props
{
    power_source_count: number;
    carbon_output_percentage: number;
    carbon_target: number;
}

import './CarbonMetre.scss';

class CarbonMetre extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    getOutputColour = () : string =>
    {
        const {carbon_output_percentage} = this.props;

        const colour_scale: Scale = scale(
            [
                '#ff0000',
                '#fcb425',
                '#fff600',
                '#7bd125',
                '#6ee524',
                '#60ff11',
            ]);

        // console.group('getOutputColour');
        // console.log('colour_scale', colour_scale);
        // console.log('carbon_output', carbon_output);
        // console.log('carbon_target', carbon_target);
        // console.groupEnd();

        return colour_scale(carbon_output_percentage * 0.01 ).hex();
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {carbon_output_percentage} = this.props;

        const value_width: string = `${carbon_output_percentage}%`;
        const value_colour: string = this.getOutputColour();

        return <div styleName={'carbon-metre'}>

           <span styleName={'metre-label'}>low carbon generation</span>

            <div styleName={'metre'}>

                <span styleName={'end-label'}>0%</span>

                <div styleName={'metre-measure'}>

                    <div
                        styleName={'metre-value'}
                        style={{ width: value_width, backgroundColor: value_colour }} />

                    <div styleName={'metre-value-indicator'} style={{ left: value_width }}>
                        {value_width}
                    </div>

                    <div styleName={'target-marker'}/>

                </div>

                <span styleName={'end-label'}>100%</span>

            </div>

        </div>
    }
}


const mapStateToProps = (state, props) =>
{
    return {
        power_source_count: countPowerSources(state),
        carbon_output_percentage: getCarbonOutputPercentage(state),
        carbon_target: getCarbonOutputTarget(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(CarbonMetre);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/game-ui/carbon-metre/CarbonMetre.tsx